import { AlertNotification, AlertNotificationType } from 'state/slices/notification';
import { v4 as uuidv4 } from 'uuid';

export const createAlertNotification = (
  message: string,
  type?: AlertNotificationType,
): AlertNotification => {
  const alertNotification: AlertNotification = {
    id: uuidv4(),
    message,
    type: type || AlertNotificationType.Info,
  };
  return alertNotification;
};
